import Project from "../components/Project"

const Projects = () => {
    return (
            <>
            <Project />
            </>
    )
}

export default Projects
